import 'bootstrap/dist/css/bootstrap.min.css';
import { Button } from 'primereact/button';
import { Card } from 'primereact/card';
import { Dropdown } from 'primereact/dropdown';
import { saveAs } from 'file-saver';
import { FileUpload } from 'primereact/fileupload';
import { Dialog } from 'primereact/dialog';
import { InputText } from 'primereact/inputtext';
import { Toast } from 'primereact/toast';
import React, { useEffect, useRef, useState } from 'react';
import S3 from "react-aws-s3";
import apis from '../../api';
import { Div, Form, FormGroup, Forms, Label } from './AccountingConf.styles';
import Video from '../Video/Video';
import { Link } from 'react-router-dom';
import SkeletonTable from '../SkeletonTable/SkeletonTable';
import './AccountingConf.css'
import ConfBar from '../ConfBar/ConfBar';

/* =============================================================================
Remuner software (c)
Vibe Consulting.
Componente : CompanyInfo
Description : Formulario de registro y configuración de la empresa
Date Autor Modification
================================================================================
30/09/2021 Santiago Coca Rojas Creación – Se implementa el forumlario desde cero.
29/10/2021 Santiago Coca Rojas Modificación - Se agragan más propiedades a la creación de la compañía
02/03/2022 Santiago Coca Rojas Documentación - Se documenta el componente teniendo en cuenta los cambios realizados con PrimeReact
================================================================================ */

export default function AccountingConf(props) {

    /*Propiedades del componente*/
    const [conf, setConf] = useState('');
    const [confList, setConfList] = useState([]);
    const [process, setProcess] = useState('');
    const [processList, setProcessList] = useState([]);

    const [loading1, setLoading1] = useState(false);
    const [loadPage, setLoadPage] = useState(false)

    /*Constantes globales del componente*/
    const headers = { Authorization: localStorage.getItem("token") }
    const elementWidth = { width: "20rem" }
    const labelStyle = { width: "28rem" }
    const cardStyle = {
        width: "60vw", marginBottom: "1rem", justifyContent: "center",
        boxShadow: '0px 3px 5px rgba(0, 0, 0, 0.06), 0px 7px 9px rgba(0, 0, 0, 0.12), 0px 20px 25px -8px rgba(0, 0, 0, 0.18)'
    }
    const fileUploadRef = useRef(null);
    const fileUploadRef2 = useRef(null);

    const toast = useRef(null);

    useEffect(() => {
        const getLists = async () => {
            await apis.getAccountingConfList(headers).then(res => {
                let data = res.data;
                setConfList(data["LITE_PLANOS_CONTABLES"] ? data["LITE_PLANOS_CONTABLES"] : []);
                setProcessList(data['CTB_PROC_PER'] ? data['CTB_PROC_PER'] : [])
            })
        }
        getLists()
    }, [])

    useEffect(() => {
        const getConf = async () => {
            await apis.getAccountingConf(localStorage.getItem('entity'), localStorage.getItem('client'), headers).then(res => {
                let data = res.data
                if (data["LITE_PLANOS_CONTABLES"]) {
                    setConf({
                        detail_id: data["LITE_PLANOS_CONTABLES"].split("|")[0],
                        description: data["LITE_PLANOS_CONTABLES"].split("|")[1]
                    })
                }
                if (data["CTB_PROC_PER"]) {
                    setProcess({
                        detail_id: data["CTB_PROC_PER"].split("|")[0],
                        description: data["CTB_PROC_PER"].split("|")[1]
                    })
                }
                setLoadPage(true)
            })
        }
        getConf()
    }, [])

    function handleSubmit(event) {
        event.preventDefault();
    }

    const showConfirm = (process) => {
        /* Función encargada de mostrarle al usuario un mesaje de confirmación de la realización del proceso*/
        toast.current.show({
            severity: 'success', sticky: true, content: (
                <div className="flex flex-column" style={{ flex: '1' }}>
                    <div className="text-center">
                        <i className="pi pi-check-circle" style={{ fontSize: '3rem', color: "green" }}></i>
                        <p>Solicitud {process} existosamente</p>
                    </div>
                </div>
            )
        });
    }

    async function putConf() {
        const _cliente = localStorage.getItem('client');
        const _entity = localStorage.getItem('entity');

        const data = {
            CLIENT: _cliente,
            ENTITY: _entity,
            LITE_PLANOS_CONTABLES: conf.detail_id,
            CTB_PROC_PER: process.detail_id
        }

        try {
            await apis.puttAccountingConf(data, headers).then(res => {
                toast.current.show({ severity: 'success', summary: 'Éxito', detail: 'Configuración exitosa' });
                setLoading1(false);
            })
        }
        catch (err) {
            setLoading1(false);
            toast.current.show({ severity: 'warn', summary: 'Aviso', detail: err.response.data.message, sticky: true });
        }
    }

    /*Renderizado del componente*/
    return (
        <div className="flex flex-wrap align-items-center justify-content-center card-container flex-column">
            <Toast ref={toast} style={{ backgroundColor: 'white' }} />
            <div className="flex flex-row align-items-center justify-content-center mb-3 mt-6 font-bold text-4xl">
                <span className="text-900">Configuración</span>
                {/* <Video header="Instructivo habilitación nómina electrónica" url={localStorage.getItem('PROCESSDIAN_VIDEO')} /> */}
            </div>
            <ConfBar />
            <SkeletonTable load={loadPage} width='80vw'>
                <div className='flex justify-content-center align-content-center flex-column mt-4'>
                    <Card style={cardStyle}>
                        <div className='flex flex-row gap-2'>
                            <FormGroup>
                                <Label htmlFor="label">Sistema de información contable a utilizar:</Label>
                                <Dropdown className="dd1" value={conf}
                                    filter filterBy="description"
                                    options={confList}
                                    onChange={(e) => {
                                        setConf(e.value);
                                    }}
                                    emptyMessage={"No hay opciones disponibles"}
                                    placeholder={conf ? conf.description : "Seleccione"} optionLabel='description'
                                />
                            </FormGroup>
                            <FormGroup className={processList.length === 0 && 'hidden'}>
                                <Label htmlFor="label">¿Cómo se realizará el proceso de contabilización?</Label>
                                <Dropdown className="dd1" value={process}
                                    filter filterBy="description"
                                    options={processList}
                                    onChange={(e) => {
                                        setProcess(e.value);
                                    }}
                                    emptyMessage={"No hay opciones disponibles"}
                                    placeholder={process ? process.description : "Seleccione"} optionLabel='description'
                                />
                            </FormGroup>
                        </div>
                    </Card>
                    <Button label="Guardar"
                        // disabled={!conf} 
                        loading={loading1} style={{ width: '12rem', alignSelf: 'center' }} onClick={() => { setLoading1(true); putConf() }} />
                </div>
            </SkeletonTable>
        </div>
    );
}